import { fetcher } from 'services/helpers/responseHandler'

const getUserRolesForAllHotels = async userId =>
  await fetcher.get(`roles/user`, { userId })

const updateUserRolesForAllHotels = async ({ userId, subsidiaries }) =>
  fetcher.put(`roles/user`, { userId, subsidiaries })

const rolesApi = {
  getUserRolesForAllHotels,
  updateUserRolesForAllHotels
}

export default rolesApi
